import { render } from "./icebreakers-checkbox.vue?vue&type=template&id=9e6a2a1e&lang=pug"
import script from "./icebreakers-checkbox.vue?vue&type=script&lang=js"
export * from "./icebreakers-checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__